"use strict";

exports.__esModule = true;
exports.xValueFormatter = exports.getYValueFormatter = exports.getChartProps = exports.formatMultiDataItemData = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _vimanaTypes = require("@vimana/vimana-types");
var _libCalendar = require("@vimana/lib-calendar");
var _legendContentFormatter = require("./legendContentFormatter");
var _Theme = require("../../../Theme");
var _constants = require("../../../Recharts/constants");
var _luxon = require("luxon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var xValueFormatter = exports.xValueFormatter = function xValueFormatter(data) {
  var _data$;
  return _momentTimezone["default"].utc((_data$ = data[0]) == null || (_data$ = _data$.payload) == null ? void 0 : _data$.key).format(_constants.TIMESTAMP_FORMAT);
};
var getYValueFormatter = exports.getYValueFormatter = function getYValueFormatter(dataItems) {
  return function (data) {
    return data.reduce(function (yValues, _ref) {
      var name = _ref.name,
        payload = _ref.payload;
      var dataItemProps = dataItems.find(function (dataItem) {
        return (dataItem == null ? void 0 : dataItem.name) === name;
      });
      if (!dataItemProps) {
        return yValues;
      }
      return [].concat(yValues, [{
        name: name,
        color: (dataItemProps == null ? void 0 : dataItemProps.color) || (0, _Theme.val)("DefaultChartColor"),
        value: payload == null ? void 0 : payload.value
      }]);
    }, []);
  };
};

/**
 * `formatMultiDataItemData` formats the time to plant timezone
 * It also removes data that lies outside Y domain and adds the dataItem details to the data object
 * */
var formatMultiDataItemData = exports.formatMultiDataItemData = function formatMultiDataItemData(_ref2) {
  var data = _ref2.data,
    dataItems = _ref2.dataItems,
    timezone = _ref2.timezone,
    minYValue = _ref2.minYValue,
    maxYValue = _ref2.maxYValue;
  return data.map(function (dataItemData, index) {
    return Object.assign({}, dataItemData, dataItems[index], {
      data: dataItemData.data.reduce(filterEventsInRange(minYValue, maxYValue, {
        timezone: timezone
      }), [])
    });
  });
};
var filterEventsInRange = function filterEventsInRange(min, max, _ref3) {
  var timezone = _ref3.timezone;
  return function (eventsInRange, _ref4) {
    var key = _ref4.key,
      value = _ref4.value;
    if (typeof min !== "undefined" && value < min) {
      return eventsInRange;
    }
    if (typeof max !== "undefined" && value > max) {
      return eventsInRange;
    }
    var parsedValue = parseFloat(value);
    return [].concat(eventsInRange, [{
      key: toTimezoneTime(key, timezone),
      value: isNaN(parsedValue) ? value : parsedValue
    }]);
  };
};
var toTimezoneTime = function toTimezoneTime(key, timezone) {
  return key + (0, _libCalendar.getTimezoneOffsetMillis)(timezone.name, key);
};
var getChartProps = exports.getChartProps = function getChartProps(_ref5) {
  var formattedData = _ref5.formattedData,
    dataItems = _ref5.dataItems;
  var legendProps = {
    formatter: (0, _legendContentFormatter.legendContentFormatter)(formattedData)
  };
  var tooltipProps = {
    xValueFormatter: xValueFormatter,
    yValueFormatter: getYValueFormatter(dataItems)
  };
  return {
    legendProps: legendProps,
    tooltipProps: tooltipProps
  };
};